export default "__VITE_ASSET__BLVH8cFk__"